import { Globe } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { useI18n } from "../../i18n/I18nProvider";
import { config } from "../../lib/config";

export function LanguageSelect({ testid = "language-select" }) {
  const { lang, setLang, t } = useI18n();
  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid={testid} aria-label={t("nav.language")} className="h-10 w-auto gap-1.5 rounded-full border-sky-200 bg-white px-3 font-bold text-[#17345F]">
        <Globe className="h-4 w-4 text-[#237BE8]" aria-hidden />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {config.languages.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`${testid}-option-${l.code}`}>{l.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
